import React from "react";
import './style.less';
import { Row, Col, Image, Carousel } from "antd";

export default class MobileServiceContent1 extends React.Component {
  
    render() {
        let list = [
            {
                key: 1,
                imgSrc: "http://qiniu.metridynamic.com/image/service/service1.png",
                title: "设备维修",
                content: "力动几何保证提供给用户的各种设备能正常运行，如果在质保期间因设备质量问题发生故障，力动几何将调查故障原因并免费修复直至满足要求，或更换整机或有缺陷的材料部件。"
            },
            {
                key: 2,
                imgSrc: "http://qiniu.metridynamic.com/image/service/consulte.png",
                title: "技术咨询/支持服务",
                content: "力动几何可为用户系统扩充、升级、与其他系统对接、测试、演示、培训等需求，提供全方位的硬件及软件解决方案，并可派技术人员上门到现场提供技术服务。"
            },
            {
                key: 3,
                imgSrc: "http://qiniu.metridynamic.com/image/service/maintain.png",
                title: "系统保养服务",
                content: "用户可根据随机附带的保养手册进行日常定期保养, 力动几何售后服务人员也可上门为用户提供系统的保养维护服务。"
            },
            {
                key: 4,
                imgSrc: "http://qiniu.metridynamic.com/image/service/update.png",
                title: "软硬件更新维护",
                content: "力动几何对软件提供运行维护服务，同时开发部门将不断完善产品原有功能，开发新功能，促使产品不断升级。若系统软件自然升级，我们承诺将免费提供给买方，保证新旧版本完全兼容，并可将旧版本升级为新版本。"
            }
        ]
        return (
            <div className={'mobile-service-content1'}>
                <div className={'content-box'}>
                    <Carousel autoplay>
                        {
                            list.map(item=>{
                                return   <div className="explain-service">
                                            <Image preview={false} height={120} style={{width:120}} src={item.imgSrc}/>
                                            <p className={"title"}>{item.title}</p>
                                            <p className={"content"}>{item.content}</p>
                                        </div>
                            })
                        }
                    </Carousel>
                </div>
            </div>
        )
    }
}
